import {
	ClockCircleOutlined,
	PlusOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { InfoContainer } from "views/desktop/components/TicketScreenCard/TicketScreenCard.styles";
import { TicketScreenCard } from "views/desktop/components/TicketScreenCard";
import { download as dowloadTicketAction } from "lib/downloadTickets";
import { getPeopleAhead } from "lib/helpers/getPeopleAhead";
import { getWaitStimated } from "lib/getWaitStimated";
import { pathOr } from "ramda";
import NotificationModal from "views/mobile/components/Popup/NotificationModal";
import OfficeDesktopLayout from "views/components/OfficeDesktopLayout";
import Provider from "views/components/TicketScreen";
import React from "reactn";

const TicketScreen = ({
	user,
	peopleAhead,
	wait,
	loadingWait,
	loadingLines,
	isLoggedInTemporary,
	userId,
	ticket,
	office,
	line,
	isVisibleNotificationModal,
	never_show_popup_notifications,
	setCloseModal,
	setModalState,
	setPreferences,
	push,
}) => {
	const { name, call } = line || {};
	const avgElapsed = pathOr(0, ["raw_tickets", "avg_elapsed", "mean"], line);

	const waitingTicket =
		call && call?.prefix !== null
			? `${call?.prefix}${call?.number}`
			: "N/A";

	const ticketNumber = pathOr(null, ["number"], ticket);
	const currentTicket = pathOr(null, ["call", "number"], line);
	const inserted_at = pathOr(null, ["call", "inserted_at"], line);

	const peopleAheadTicket = getPeopleAhead(
		ticketNumber,
		currentTicket,
		inserted_at
	);

	const realWaitStimated = getWaitStimated(peopleAheadTicket, avgElapsed);

	const virtualRoom = pathOr(false, ["options", "virtualRoom"], office);
	return (
		<>
			{!isLoggedInTemporary && (
				<>
					{isVisibleNotificationModal &&
						(!never_show_popup_notifications ||
							never_show_popup_notifications === false) &&
						(!push || push === false) && (
							<NotificationModal
								user={userId}
								onClose={setCloseModal}
								setModalState={setModalState}
								setPreferences={setPreferences}
							/>
						)}
				</>
			)}
			<OfficeDesktopLayout
				user={user}
				line={name}
				office={office}
				title={`Ticket de atención: `}
			>
				<InfoContainer>
					<div>
						<span>
							<UserOutlined style={{ fontSize: 24 }} />
							{peopleAheadTicket > 0
								? peopleAheadTicket - 1
								: "-"}
						</span>
						<p>Personas antes de ti</p>
					</div>
					<div>
						<span style={{ width: "80%" }}>
							<ClockCircleOutlined style={{ fontSize: 24 }} />
							{realWaitStimated}
						</span>
						<p>Minutos de espera</p>
					</div>
					<div>
						<span>
							{call && parseInt(call?.number) > 0
								? waitingTicket
								: "-"}
						</span>
						<p>Ticket en atención</p>
					</div>
				</InfoContainer>

				<TicketScreenCard
					office={office}
					line={line}
					ticket={ticket}
					peopleAhead={peopleAhead}
					wait={wait}
					loadingWait={loadingWait}
					loadingLines={loadingLines}
					dowloadTicketAction={dowloadTicketAction}
					virtualRoom={virtualRoom}
				/>
			</OfficeDesktopLayout>
		</>
	);
};

export default Provider(TicketScreen);
